import {AbstractControl, ValidationErrors} from '@angular/forms';

export class NegativeValidator {
  static cannotBeNegativeNumber(
    control: AbstractControl,
  ): ValidationErrors | null {
    if ((control.value as number) < 0) {
      return {cannotBeNegativeNumber: true};
    }

    return null;
  }
}
